// extracted by mini-css-extract-plugin
export default {"analysis-container":"index_analysis-container__bvIY2"};